// @flow

import ReduceStore from 'PMT/flux/ReduceStore';

// -- constant
import Events from 'constants/Events';
import ActionTypes from 'constants/ActionTypes';

// -- entity
import ApiError from 'PMT/entities/ApiError';
import PaymentStatistics from 'PMT/entities/PaymentStatistics';

class PaymentStatStore extends ReduceStore {

  getInitialState() {
    return {
      /**
       * @type PaymentStatistics
       */
      paymentStatistics: null,

      /**
       * @type ApiError
       */
      apiError: null,
    }
  }

  getStateObjectsMap() {
    return {
      apiError: new ApiError(),
      paymentStatistics: new PaymentStatistics(),
    }
  }

  getApiError(): ApiError {
    return this._state.apiError;
  }

  getPaymentStatistics(): PaymentStatistics {
    return this._state.paymentStatistics;
  }

  reduce(state, action, nextState) {
    switch(action.type) {

      case ActionTypes.LOGOUT:
      case ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST:
        return this.getInitialState();

      case ActionTypes.PAYMENT_STATISTICS_RESPONSE_SUCCESS:
        nextState.paymentStatistics = action.paymentStatistics;
        nextState.apiError = null;
        return nextState;

      case ActionTypes.PAYMENT_STATISTICS_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        return nextState;

      default:
        return nextState;
    }
  }


}

export default new PaymentStatStore();
